import React, { TouchEventHandler } from 'react'

import type { ImageApiObject } from 'src/types/image'
import Image from 'src/comps/Image'

import { getResponsiveImgProps } from './utils'
import { Thumbnail } from './styles'

const mainImageSizes = {
  desktop: {
    size: '580px',
    srcWidth: 580,
  },
  tablet: {
    size: '864px',
    srcWidth: 864,
  },
  mobile: {
    size: '100vw',
    srcWidth: 767,
  },
}

export interface MainImageProps {
  handleClick: (index?: number) => void
  pointerEvents: {
    onTouchEnd: TouchEventHandler<HTMLDivElement>
    onTouchStart: TouchEventHandler<HTMLDivElement>
  }
  photos: ImageApiObject[]
}

const MainImage = ({ handleClick, pointerEvents, photos }: MainImageProps) => {
  const [mainImage] = photos

  return (
    <Thumbnail {...pointerEvents}>
      <Image
        alt="Main Image"
        onClick={() => handleClick(0)}
        {...getResponsiveImgProps(mainImage, mainImageSizes)}
      />
    </Thumbnail>
  )
}

export default MainImage
